export default "__VITE_ASSET__nhOWb3A8__"